module.exports = __webpack_public_path__ + "static/media/insurance.88eb7887.webp";